import { Fragment } from "react";


export const vendorListData = [
    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    },

    {
        vendor:"MegaCabs",
        contact_name:'Ram Kumar',
        phone_number:"9876743210",
        address:"No 1050, sathanur village Bengaluru-560064",
        registered_date:"Jan 6, 2022"
    }
];


export const vendorFilterColums = [

    {
        name: 'VENDOR',
        value:'companyName',
        type:'text'
        
    },
    {
        name: 'CONTACT NAME',
        value:'contactPersonName',
        type:'text'
        
    },
    {
        name: 'PHONE NUMBER',
        value:'mobile',
        type:'text'
        
    },
    {
        name: 'ADDRESS',
        value:'addressLine',
        type:'text'
        
    }
 


];
 

export const vendorListColumns = [

    {
        name: 'VENDOR',
        selector: row => row['vendor'],
        sortable: true,
        // center: true,
        // width:"130px",
        
    },
    {
        name: 'CONTACT NAME',
        selector: row => row['contact_name'],
        sortable: true,
        center: true,
        // width:"180px",
    },
    {
        name: 'PHONE NUMBER',
        selector: row => row['phone_number'],
        sortable: true,
        center: true,
        // width:"150px",
    },
    {
        name: 'ADDRESS',
        selector: row => row['address'],
        sortable: true,
        center: true,
        // width:"130px",
    },
    {
        name: 'REGISTERED DATE',
        selector: row => row['registered_date'],
        sortable: true,
        center: true,
        // maxWidth:"7vw",
    },
    {
        name: '',
        selector: row => row['action'],
        sortable: true,
        center: true,
        width: "50px",
    },
    {
        name: "Deleted",
        selector: (row) => row["Deleted"],
        sortable: true,
        center: true,
        // width:"0",
        omit:true,
    },
];

export const vendorCarCurrentStatusColumns = [

    {
        name: 'DRIVER NAME',
        selector: row => row['driver_name'],
        sortable: true,
        // center: true,
        // width:"130px",
        
    },
    {
        name: 'CAB NUMBER',
        selector: row => row['cab_number'],
        sortable: true,
        center: true,
        // width:"180px",
    },
    {
        name: 'CAB TYPE',
        selector: row => row['cab_type'],
        sortable: true,
        center: true,
        // width:"150px",
    },
    {
        name: 'STATUS',
        selector: row => row['status'],
        sortable: true,
        center: true,
        // maxWidth:"7vw",
    },
    {
        name: 'AVAILABILITY',
        selector: row => row['driver_is_available'],
        sortable: true,
        center: true,
        // maxWidth:"7vw",
    },
    // {
    //     name: '',
    //     selector: row => row['action'],
    //     sortable: true,
    //     center: true,
    //     width: "50px",
    // },
];

export const vendorCarCurrentStatusFilterColumns = [

    {
        name: 'CAR TYPE',
        value:'carTypeId',
        type:'select'
    },
    {
        name: "STATUS",
        value: "status",
        type: "select",
    },
    {
        name: 'DRIVER NAME',
        value:'driverName',
        type:'text'
    },
    {
        name: "CAR NUMBER",
        value: "carNo",
        type: "text",
    },
];

export const vendorTripHistoryFilterColumns = [
    {
      name: "BOOKING #",
      value: "mega_cabs_booking_no",
      type: "text",
    },
    {
      name: "CUSTOMER NAME",
      value: "cust_name",
      type: "text",
    },
    {
      name: "PHONE #",
      value: "cust_mobile",
      type: "text",
    },
    {
      name: (
        <span>
          <Fragment>
            PICKUP <i className="fa fa-map-marker"></i>
          </Fragment>
        </span>
      ),
      value: "pick_up_address",
      type: "text",
    },
    {
      name: (
        <span>
          <Fragment>
            DROP <i className="fa fa-map-marker"></i>
          </Fragment>
        </span>
      ),
      value: "dest_address",
      type: "text",
    },
    // {
    //     name: 'SERVICE CITY',
    //     selector: row => row['service_city'],
    //     sortable: true,
    //     center: true,
    // },
  ];